export enum FeatureStoreStateKey {
	APP = 'app',
	AUTH = 'auth',
	// INVOICE = 'invoice',

	CURRENT_USER = 'current-user',
	PAYMENT_TERMS = 'payment-terms',
	// TAX_TYPES = 'tax-types',
	COMPANY = 'company',
	NOTIFICATION = 'notification',
	SETTINGS_FEATURE = 'settings',
	COMPANY_SETTINGS = 'company-settings',
	MISSIONS = 'missions',
	DATATABLE_FEATURE = 'datatable',
	CUSTOMER_FEATURE = 'customer',
	TRANSACTION_FEATURE = 'transaction',
	JOURNAL_FEATURE = 'journal',
	WALLET_FEATURE = 'wallet',
	CUSTOMER = 'customer',
	PAYEE_CUSTOMER = 'payee-customer',
	SALE_INVOICE_FEATURE = 'sale-invoice',
	SALE_OVERVIEW = 'sale-overview',
	SALE_INVOICE_FORM_FEATURE = 'sale-invoice-form',
	CUSTOMER_FORM_FEATURE = 'customer-form',
	VENDOR_FORM_FEATURE = 'vendor-form',
	PAYMENT_FORM_FEATURE = 'payment-form',
	QUOTATION_FEATURE = 'quotation',
	TAX_ENTITY_FEATURE = 'tax-entity',
	PRODUCT_ENTITY_FEATURE = 'product-entity',
	INVOICE_PAYMENT_TERM_FORM = 'invoice-payment-term-form',
	DASHBOARD_WIDGET_ENTITIES_FEATURE = 'dashboard-widget-entity',
	ACCOUNT_OVERVIEW_FEATURE = 'account-overview',
	SALE_INVOICE_INTEGRATION_SOURCE_FEATURE = 'sale-invoice-integration-source-entity',
	SALE_REPORT_ENTITIES_FEATURE = 'sale-report-entity',
	ACCOUNTING = 'accounting',
	SALE = 'sales',
	USER_FEATURE = 'user',
	COMMISSION_FEATURE = 'COMMISSION',
	BANK_RECON = 'BANK RECONCILIATION',
	ACCOUNT = 'account',
	TRIAL_BALANCE = 'trial-balance',
	PAYMENT_METHOD = 'payment-method',
	CATEGORY = 'category',
	VENDOR = 'vendor',
	PROJECT = 'project',
	DEPARTMENT = 'department',
	PRODUCT_SERIVCE = 'product-service',
	INVENTORY = 'inventory',
	PURCHASE_INVOICE_FEATURE = 'purchase-invoice',
	BRANCH = 'branch',
	TOKEN = 'token',
}

export enum ActionSourceKey {
	//USER / CONTAINER ACTIONS
	WALLET_DETAIL_CONTAINER = 'Wallet Detail Container',
	SALE_TABLE_FILTER_CONTROL_CONTAINER = 'Sale Table Filter Control Container',
	SALE_TABLE_CONTAINER = 'Sale Table Container',
	SALE_TABLE_BREADCRUMB_CONTAINER = 'Sale Table Breadcrumb Container',
	SALE_OVERVIEW_CONTAINER = 'Sale Overview Container',
	SALE_INVOICE_PREVIEW_CONTAINER = 'Sale Invoice Preview',
	SALE_FILTER_CONTINER = 'Sale Filter Container',
	RECENT_UPDATED_INVOICE_CONTAINER = 'Recent Updated Invoice Container',
	MAIN_NAVIGATION_CONTAINER = 'Main Navigation Container',
	INVOICE_FORM_DETAILS_CONTAINER = 'Invoice Form Details Container',
	INVOICE_FORM_LINE_ITEMS_CONTAINER = 'Invoice Form Line Items Container',
	INVOICE_FORM_SUMMARY_CONTAINER = 'Invoice Form Summary Container',
	INVOICE_FORM_HEADER_CONTAINER = 'Invoice Form Header Container',
	INVOICE_FORM_PAYEE_CONTAINER = 'Invoice Form Payee Container',
	INVOICE_FORM_ATTACHMENT_CONTAINER = 'Invoice Form Attachment Container',
	PAYMENT_FORM_CONTAINER = 'Payment Form Container',
	PAYMENT_FORM_ACTIONS_CONTAINER = 'Payment Form Actions Container',
	PAYMENT_FORM_BULK_CONTAINER = 'Payment Form Container',
	PAYMENT_OVERVIEW_CONTAINER = 'Payment Overview Container',
	BRANCH_CHANGER_CONTAINER = 'Branch Changer Container',
	FOOTER_CONTAINER = 'Footer Container',
	QUOTATION_TABLE_FILTER_CONTROL_CONTAINER = 'Quotation Table Filter Control Container',
	QUOTATION_TABLE_CONTAINER = 'Quotation Table Container',
	QUOTATION_TABLE_BREADCRUMB_CONTAINER = 'Quotation Table Breadcrumb Container',
	QUOTATION_PREVIEW_CONTAINER = 'Quotation Preview',
	QUOTATION_FILTER_CONTAINER = 'Quotation Filter Container',
	RECENT_UPDATED_QUOTATION_CONTAINER = 'Recent Updated Quotation Container',
	PAYMENT_TERM_FORM_CONTAINER = 'Payment Term Form Container',
	DATATABLE_CONTAINER = 'DataTable Container',
	DASHBOARD_WIDGET_CONFIG_CONTAINER = 'Dashboard Widget Config Container',
	DASHBOARD_WIDGET_SELECTION_CONTAINER = 'Dashboard Widget Selection Container',
	INVOICE_VIEW_CONTAINER = 'Invoice View Container',
	INVOICE_ARCHIVE_DIALOG_CONTAINER = 'Invoice Archive Dialog Container',
	SALE_INVOICE_INTEGRATION_SOURCE_CONTAINER = 'Sale  Invoice Integration Source Container',
	MAIN_PORTAL_HEADER_CONTAINER = 'Main Portal Header Container',
	DASHBOARD_PAGE_CONTAINER = 'Dashboard Page Container',
	INVOICE_PRINT_CONTAINER = 'Invoice Print Container',
	SALE_REPORT_CONTAINER = 'Sale Report Container',
	SALE_REPORT_FILTER_SIDENAV = 'Sale Report Filter Sidenav',
	ACCOUNTING_PROFIT_LOSS = 'Accounting Profit Loss',
	CUSTOMER_TABLE_CONTAINER = 'Customer Table Container',
	CUSTOMER_DROPDOWN = 'Customer Dropdown List',
	JOURNAL_FORM = 'Journal Form',
	JOURNAL_TABLE_CONTAINER = 'Journal Table Container',
	JOURNAL_DETAIL_CONTAINER = 'Journal Detail Container',
	TRANSACTION_TABLE_CONTAINER = 'Transaction Table Container',
	TRANSACTION_DETAIL_CONTAINER = 'Transaction Detail Container',
	TRANSACTION_RECEIVE_PAYMENT_DIALOG = 'Transaction Receive Payment Dialog',
	TRANSACTION_MAKE_PAYMENT_DIALOG = 'Transaction Make Payment Dialog',
	TRANSACTION_KNOCK_OFF_INVOICE_DIALOG = 'Transaction Knock Off Invoice Dialog',
	TRANSACTION_FUND_TRANSFER_DIALOG = 'Transaction Fund Transfer Dialog',
	ACTIVITY_FEED_CONTAINER = 'Activity Feed Container',

	VENDOR_TABLE_CONTAINER = 'Vendor Table Container',
	VENDOR_DETAIL_CONTAINER = 'Vendor Detail Container',
	VENDOR_DROPDOWN = 'Vendor Dropdown List',
	CUSTOMER_DETAIL_CONTAINER = 'Customer Detail Container',
	TRIAL_BALANCE_REPORT = 'Trial Balance Report',
	CASHFLOW_REPORT = 'Cashflow Report',

	//SYSTEM / EFFECTS / SERVIE ACTIONS
	//SYSTEM / EFFECTS / SERVIE ACTIONS
	PAYMENT_FORM_EFFECTS = 'Payment Form Effects',
	PAYMENT_FORM_DIALOG_EFFECTS = 'Payment Form Dialog Effects',
	INVOICE_FORM_SUBITEM_FORM_EFFECTS = 'Invoice Form Sub Item Form Effects',
	INVOICE_FORM_MAIN_EFFECTS = 'invoice Form Main Effects',
	INVOICE_DOWNLOAD_EFFECTS = 'Invoice Download Effects',
	INVOICE_EMAIL_EFFECTS = 'Invoice Email Effects',
	INVOICE_ARCHIVE_EFFECTS = 'Invoice Archive Effects',
	INVOICE_FORM_PAYEE_EFFECTS = 'Invoice Form Payee Effect',
	INVOICE_FORM_CUSTOM_FIELD_EFFECTS = 'Invoice Form Custom Field Effects',
	INVOICE_FORM_LINE_ITEM_EFFECTS = 'Invoice Form Line Item Effects',
	INVOICE_FORM_SUMMARY_EFFECTS = 'Invoice Form Summary Effects',
	INOVICE_ENTITY_EFFECTS = 'Invoice Entity Effects',
	BRANCH_EFFECTS = 'Branch Effects',
	SALE_OVERVIEW_EFFECTS = 'Sale Overiew Effects',
	TAX_ENTITY_EFFECTS = 'Tax Entity Effects',
	PRODUCT_ENTITY_EFFECTS = 'Product Entity Effects',
	PAYMENT_TERM_FORM_EFFECTS = 'Payment TERm Form Effects',
	PAYMENT_TERM_EFFECTS = 'Payment Term Effects',
	CUSTOMER_QUICK_SEARCH_EFFECTS = 'Customer Quick Search Effects',
	DASHBOARD_WIDGET_EFFECTS = 'Dashboard Widget Effects',
	SALE_INVOICE_INTEGRATION_SOURCE_EFFECT = 'Sale Invoice Integration Source Effects',
	CUSTOMER_ENTITY_EFFECTS = 'Customer Entity Effects',
	CUSTOMER_FORM_EFFECTS = 'Customer Form Effects',
	RECEIVE_FORM_EFFECTS = 'Receive Payment Form Effects',
	JOURNAL_ENTITY_EFFECTS = 'Journal Entity Effects',
	PROJECT_EFFECTS = 'Project Effects',
	DEPARTMENT_EFFECTS = 'Department Effects',
	TRANSACTION_ENTITY_EFFECTS = 'Transaction Entity Effects',
	WALLET_ENTITY_EFFECTS = 'Wallet Entity Effects',

	VENDOR_ENTITY_EFFECTS = 'Vendor Entity Effects',
	VENDOR_FORM_EFFECTS = 'Vendor Form Effects',
	TRIAL_BALANCE_EFFECTS = 'Trial Balance Effects',
	COMPONENT_STORE = 'Component Store',
	CASHFLOW_COMPONENT_STORE = 'Cashflow Component Store',

	SCREEN_EFFECTS = 'Screen Effects',
	ROLE_PERMISSION_EFFECTS = 'Role Permission Effects',
	NOTICE_EFFECTS = 'Notice Effects',
	NOTIFICATION_EFFECTS = 'Notification Effects',
	MISSION_EFFECTS = 'Mission Effects',
	INVALID_TOKEN_EFFECTS = 'Invalid Token Effects',
	CURRENT_USER_EFFECTS = 'Current User Effects',
	CLIENT_EFFECTS = 'Client Effects',
	AUTH_TOKEN_EFFECTS = 'Auth Token Effects',
	API_SERVICE = 'API Service',
	CHART_ACCOUNT = 'chart Of Account',
	ACCOUNT_TYPE = 'account type',
	SETTING_EFFECTS = 'Settings Effects',

	CLICK = 'Click',

	/**@deprecated */
	APP = 'app',
	/**@deprecated */
	INVOICE = 'invoice',
	/**@deprecated */
	CURRENT_USER = 'current-user',
	/**@deprecated */
	NOTICE = 'notice',
	/**@deprecated */
	SETTINGS = 'settings',
	/**@deprecated */
	MISSIONS = 'missions',
	SALE = 'SALE',

	ACTION_FILTER = 'FILTER',

	SALES_PERSON = 'SALESPERSON',

	// container
	CONTAINER_FILTER = 'Filter Sidenav',

	LEDGER = 'Ledger',

	// report
	SALE_REPORT = 'SALE REPORT',
	WALLET_STATEMENT = 'Wallet Statement',
	COMMISSION_REPORT = 'Commission Report',
	SALE_SUMMARY = 'Sales Summary',
	SALE_SUMMARY_DETAIL = 'Sales Summary Detail',
	CUSTOMER_STATEMENT = 'Customer Statement',
	BALANCE_SHEET = 'Balance Sheet',
	PROFIT_LOSS = 'Profit & Loss',
	TRIAL_BALANCE = 'Trial Balance',
	TRANSACTION = 'Transaction',
	CREDITOR = 'Creditor',
	// add type of activity here, e.g. click "Apply filter"
	ACTIVITY_INIT = 'On Init',
	ACTIVITY_DATE_CHANGED = 'On Date Changed',
	ACTIVITY_APPLY_FILTER = 'On Apply Filter',
	ACTIVITY_APPLY_SORTING = 'On Apply Sorting',
	// add type of method here, e.g. saving/creating
	METHOD_GET = 'GET',
	METHOD_SAVE = 'SAVE',
	METHOD_UPDATE = 'UPDATE',
	METHOD_DELETE = 'DELETE',
	METHOD_RETRIVE_SUCCESS = 'SUCCESS RETRIEVE',
	METHOD_RETRIVE = 'RETRIEVE',
	METHOD_SEARCH = 'SEARCH',
	METHOD_PRINT = 'PRINT',
	// status
	STATUS_SUCCESS = 'SUCCESS',
	STATUS_FAIL = 'FAIL',
	// Customer
	CUSTOMER_FILTER_CONTAINER = 'Customer Filter Container',
	CUSTOMER = 'CUSTOMER',
	CUSTOMER_ARCHIVE_DIALOG_CONTAINER = 'Customer Archive Dialog Container',
	CUSTOMER_ARCHIVE_EFFECTS = 'Customer Archive Effects',
	CUSTOMER_FORM_CONTAINER = 'Customer Form Container',
	CUSTOMER_PAYMENT_DIALOG_CONTAINER = 'Customer Payment Dialog Container',

	VENDOR_FILTER_CONTAINER = 'Vendor Filter Container',
	VENDOR_ARCHIVE_DIALOG_CONTAINER = 'Vendor Archive Dialog Container',
	VENDOR_ARCHIVE_EFFECTS = 'Vendor Archive Effects',
	VENDOR_FORM_CONTAINER = 'Vendor Form Container',
	VENDOR_PAYMENT_DIALOG_CONTAINER = 'Vendor Payment Dialog Container',

	LINK_AN_ACCOUNT_DIALOG_CONTAINER = 'Link An Account Dialog Container',
}
